import React, { useState, useEffect } from "react";
import { Modal, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../../context/user_context";
import { naira } from "../../../utils/data";
import { Button } from "../../../styles";
import { usePackagesContext } from "../../../context/packages_context";
import Api from "../../../api/axios";
import { ICON_CASH_COIN } from "../../../utils/icons";

const PayWithWallet = (props) => {

    const [load, setload] = useState(false);

    const navigate = useNavigate();

    const {
        btoken,
        stoken,
        usertoken,
        userBalance,
        getUserBalance,
    } = useUserContext();

    const {
        showWalletPayment,
        closeWalletPayment,
    } = usePackagesContext();

    //  Get Account Balance
    useEffect(() => {
        getUserBalance();
    }, []);
    //  Get Account Balance

    // console.log(userBalance?.AvailableBalance_th);

    // On Success or Failure of Payment
    // On Success or Failure of Payment

    const updatePay = (e) => {
        e.preventDefault();
        setload(true);
        const data = {
            usertoken,
            btoken,
            stoken,
            amount: props.paymentData.amount,
            packageid: props.paymentData.pid,
            duration_days: props.paymentData.days,

        };
        Api.post(`/subscribe.wallet.reni`, data)
            .then((res) => {
                if (res.success === true) {
                    setload(false);
                    toast.success(res.message);
                    getUserBalance();
                    setTimeout(() => {
                        navigate('/user/settings/billing');
                    }, 2000);
                } else {
                    setload(false);
                    toast.warning(res.message);
                }
            })
            .catch((error) => {
                setload(false);
            });
    };
    function payConfirm(e) {
        if (window.confirm(`Are you sure you want to pay  ${ naira }${ props.paymentData.amountth } for the subscription of ${ props.paymentData.name } package for ${ props.paymentData.days } days ?`)) {
            updatePay(e);
        }
    }
    // On Success or Failure of Payment
    // On Success or Failure of Payment

    return (
        <>
            <Modal
                show={showWalletPayment}
                onHide={closeWalletPayment}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
            >
                <Modal.Body>
                    <Modal.Header closeButton>
                        <h6 className="fw-bold pry-text">
                            MAKE PAYMENT
                        </h6>
                    </Modal.Header>
                    {load ?
                        <div className="mt-5 text-center">
                            <ClipLoader color={"#023676"} loading={load} speedMultiplier="1.2" />
                            <div className="mt-4 mb-5">
                                <h5 className="fw-light">
                                    Please wait, your payment is processing{" "}
                                </h5>
                                <h6> Do not refresh page!!! </h6>
                            </div>
                        </div>
                        : (
                            <>
                                <div className="mt-3 text-center">
                                    <h5 className="fw-light pry-text">
                                        Payment for {props.paymentData.name} Package
                                    </h5>
                                    <hr />
                                    <h1 className="pry-text">
                                        {ICON_CASH_COIN}
                                    </h1>
                                    <h5 className=" fw-light pry-text mt-2">
                                        Amount
                                    </h5>
                                    <h1 className=" pry-text mt-3">
                                        ₦ {props.paymentData.amountth}
                                    </h1>
                                    <Alert color="primary fit-content mx-auto">
                                        Account balance: ₦{userBalance?.AvailableBalance_th || '0.00'}
                                    </Alert>
                                    <hr className="mt-5" />
                                    <Button
                                        pry
                                        className='btn mb-4'
                                        onClick={e => payConfirm(e)}>
                                        Pay with wallet
                                    </Button>
                                </div>
                            </>
                        )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PayWithWallet;
